import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/TerminalHandling/TPTRequestDetails.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import unchecked from '../../../Assets/TruckVisits/Assets/unchecked-box.svg';
import checked from '../../../Assets/NominateRequest/selectedCheckBox.svg';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import 'react-calendar/dist/Calendar.css';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { TERMINAL_HANDLING_ENDPOINT } from '../../../Services/config/apiEndPoints';

class TPTRequestDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {}
        }
    }

    getTPTRequestHistory = (orderId) => {
        ApiCall(
            'GET',
            serviceBaseURL + TERMINAL_HANDLING_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((apiData) => {

            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log("in 500");
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData);
                    const filteredData = apiData?.filter(name => name.requestId == orderId);
                    console.log('order--', filteredData[0]);
                    this.setState({ data: filteredData[0] });
                }
            }
        });

    }

    componentDidMount = () => {
        const { orderId } = this.props.match.params;
        if (!this.props.history.location.state) {
            this.getTPTRequestHistory(orderId);
        } else {
            this.setState({ data: this.props.history.location.state })
        }
    }
    getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }

    render() {
        return (
            <div class="TptReqestDetailsOutercolor">
                <MetaDecorator title={TitleDescription.TPTRequestDetailsTitle} description={TitleDescription.TPTRequestDetailsDiscription} />
                <Header tilesFetched={() => { }} />
                <div class="TptReqestDetailsOuterDivcss">
                    <div id="TptReqestDetailsBoxDiv">
                        <nav class="TptReqestDetailsNavbar">
                            <div className="TptReqestDetailsNavbarName">
                                <small id="TptReqestDetailsNavbarText">Request Service</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="TptReqestDetailsMidPartition">
                            <div class="TptReqestDetailsCrdHeading">Customer Details</div>
                            <div class="TptReqestDetailsCardcss">
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Name of Company</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.companyName}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Contact Person</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.contactPerson}</div>
                                </div>
                            </div>
                            <div class="TptReqestDetailsCrdHeading">Contact Details</div>
                            <div class="TptReqestDetailsCardcss">
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Email Address</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.email}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Telephone No.</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.telephone}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Fax No.</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.fax}</div>
                                </div>
                            </div>
                            <div class="TptReqestDetailsCrdHeading">Transport Terminal Details</div>
                            <div class="TptReqestDetailsCardcss">
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Transnet Port Terminal Account No.</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.accountNbr}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Select Terminal</small>
                                    <div id="TptReqestDetailsInpHeadBtm">(Select at which terminal at service to be provided)</div>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.terminal}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Select Type of Service Required</small>
                                    <div class="TptReqestDetailsServiceTypeDiv">
                                        <div id="TptReqestDetailsSvcCheckdivid1" class="TptReqestDetailsSvcCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.serviceType == 'Shipping' ? checked : unchecked}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Shipping</div>
                                        </div>
                                        <div id="TptReqestDetailsSvcCheckdivid2" class="TptReqestDetailsSvcCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.serviceType == 'Landing' ? checked : unchecked}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Landing</div>
                                        </div>
                                        <div id="TptReqestDetailsSvcCheckdivid3" class="TptReqestDetailsSvcCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.serviceType == 'Other' ? checked : unchecked}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Other</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Commodity</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.commodity}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">State If You Require Fines or Storage</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.commodityStatement}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <div id="TptReqestDetailsRiskInpHeading">Does/Can The Commodity Pose Any Environmental/Health Risks</div>
                                    <div class="TptReqestDetailsServiceTypeDiv">
                                        <div class="TptReqestDetailsRisksCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.risk ? checked : unchecked}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Yes</div>
                                        </div>
                                        <div class="TptReqestDetailsRisksCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={!this.state.data?.responseData?.risk ? checked : unchecked}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">No</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Environmental / Health Risks</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.riskStatement}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Enter Dimensions</small>
                                    <div className="pass-wrapper" id="TptReqestDetailsInpDimensionDiv" >
                                        <div class="TptReqestDetailsDimensionSmDiv">
                                            <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.length} mm</div>
                                        </div>
                                        <div class="TptReqestDetailsDimensionSmDiv">
                                            <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.breadth} mm</div>
                                        </div>
                                        <div class="TptReqestDetailsDimensionSmDiv">
                                            <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.height} mm</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Select Cargo Packaging</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.cargoPacking}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">If Vehicles on Tracks or Wheels Please Select</small>
                                    <div class="TptReqestDetailsServiceTypeDiv">
                                        <div class="TptReqestDetailsSvcCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.vehicleType === "Tracks" ? selectedRadioButton : defautRadioButton}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Tracks</div>
                                        </div>
                                        <div class="TptReqestDetailsSvcCheckdiv">
                                            <img id="TptReqestDetailsSvcCheck_img"
                                                src={this.state.data?.responseData?.vehicleType === "Wheels" ? selectedRadioButton : defautRadioButton}

                                            />
                                            <div class="TptReqestDetailsSvcChecktext">Wheels</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Tonnage per Item</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.tonnagePerItem}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Total Tonnage</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.totalTonnage}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Date Application Submitted</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.getDateFormated(this.state.data?.responseData?.submitDate)}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Date Service Required</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.getDateFormated(this.state.data?.responseData?.serviceDates)}</div>
                                </div>
                                <div class="TptReqestDetailsInpSize">
                                    <small id="TptReqestDetailsInpHeading">Comment</small>
                                    <div class="TptReqestDetailsDateAppSub">{this.state.data?.responseData?.comments}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="TptReqestDetailsFooterUnfixed">
                    <Footer />
                </div>
                <div class="TptReqestDetailsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}

export default TPTRequestDetails;